import styled from 'styled-components';
import { spacer8, spacer16, spacer20 } from '@spotify-internal/encore-foundation';
import { dialog } from "../../styles";
export default styled.div.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "Dialog",
  componentId: "esewol-0"
})(["", ";padding:", " ", " ", ";width:335px;"], function (props) {
  return dialog(props.theme.dialogAlert === 'dark');
}, spacer16, spacer20, spacer8);